import React, { useState } from 'react';
import './Footer.scss';
import logo from './../images/logo.png';

import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import GitHubIcon from '@mui/icons-material/GitHub';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ShareIcon from '@mui/icons-material/Share';

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

export default function Footer() {
  const [copySuccess, setCopySuccess] = useState('Copy link');

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopySuccess('Copied!');
      setTimeout(() => {
        setCopySuccess('Copy link');
      }, 2000);
    });
  };
  return (
    <>
      <div className="footer-section">

        <div className='color-bar'>
        </div>

        <div className='footer-content content'>
          <h3 className='salamat'>Salamat sa pagbisita</h3>

          <span className='description'>Let me know you've been here!
            {/* be the first to leave a review */}
          </span>

          <img src={logo} alt="Icon" className="footer-logo" />
          {/* <br /> ReactJS • Spline*/}

          <div className="footer-icons">
            <Tippy content="Facebook" placement='bottom'>
              <a className="footerIcon facebook" target="_blank" href="https://www.facebook.com/rasheed.delacruz" >
                <FacebookIcon />
              </a>
            </Tippy>
            <Tippy content="LinkedIn" placement='bottom'>
              <a className="footerIcon linkedin" target="_blank" href="https://www.linkedin.com/in/rasheed-delacruz/" >
                <LinkedInIcon />
              </a>
            </Tippy>
            <Tippy content="Github" placement='bottom'>
              <a className="footerIcon github" target="_blank" href="https://github.com/meelvore" >
                <GitHubIcon />
              </a>
            </Tippy>
            <Tippy content="Email" placement='bottom'>
              <a className="footerIcon email" target="_blank" href="mailto:rasheed.delacruz@yahoo.com">
                <MailOutlineIcon />
              </a>
            </Tippy>
            <Tippy content={copySuccess} placement='bottom'>
              <a className="footerIcon share" onClick={() => copyToClipboard('https://sheed.netlify.app/')}>
                <ShareIcon />
              </a>
            </Tippy>
          </div>
          <span className='credit'>© 2023 - Dela Cruz, R.</span>
        </div>
      </div>
    </>
  )
}

// footer:
// logo (?)
// 2022 credits
// socials icons lang